import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, Heart } from "lucide-react";
import api from "../api";
import { ShareButtons } from "../components/ShareButtons";

export default function ReactionPage() {
  const { token } = useParams();
  const [r, setR] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get(`/reaction/${token}`).then(({ data }) => setR(data)).catch((err) => setError(err?.response?.status === 410 ? "This video is no longer available." : "This reaction link is invalid."));
  }, [token]);

  if (error) return <div className="min-h-screen flex items-center justify-center text-[#5a6b80]" data-testid="reaction-error">{error}</div>;
  if (!r) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-[#2ec9c9]" size={40} /></div>;
  const brand = r.brand_color || "#16243b";
  return (
    <div className="min-h-screen bg-[#f6f8fb] py-12 px-4" data-testid="reaction-page">
      <div className="max-w-[560px] mx-auto">
        <div className="rounded-3xl p-8 text-white mb-6" style={{ background: brand }}>
          {r.logo_url && <img src={r.logo_url} alt={r.business_name} className="max-h-12 mb-4" />}
          <p className="flex items-center gap-2 text-sm opacity-90"><Heart size={16} /> Thank-you video</p>
          <h1 className="text-2xl font-bold mt-2">{r.recipient_name || "Your recipient"} says thank you!</h1>
          <p className="opacity-80 text-sm mt-1">For the {r.product_title} voucher from {r.business_name}</p>
        </div>
        <div className="rounded-3xl overflow-hidden bg-black shadow-[0_20px_50px_rgba(20,30,55,0.18)]">
          <video src={`${process.env.REACT_APP_BACKEND_URL}${r.video_url}`} controls autoPlay playsInline className="w-full max-h-[70vh]" data-testid="reaction-player" />
        </div>
        <ShareButtons url={window.location.href} text={`${r.recipient_name || "My gift recipient"} sent me a thank-you video for my ${r.business_name} gift voucher!`} />
        {r.store_slug && (
          <Link to={`/store/${r.store_slug}`} data-testid="reaction-gift-again" className="gp-btn-teal block text-center rounded-xl py-3 font-medium mt-6">
            Send another gift from {r.business_name}
          </Link>
        )}
      </div>
    </div>
  );
}
